
export default {
    // @TechProvider
    setNewCreatedTechProvider(state, value){
        state.newCreatedTechProvider = value
    },
}